export default __webpack_public_path__ + "static/media/bs-secondary-crossover.441e4d8a.svg";